<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        :class="twClass"
    >
        <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M19.5 8.25l-7.5 7.5-7.5-7.5"
        />
    </svg>
</template>

<script setup lang="ts">
const {twClass = 'w-6 h-6 stroke-1 stroke-primary'} = defineProps<{ twClass?: string }>();
</script>
